// Alert generation for the marketing dashboard's "Needs attention" card:
// publish cadence, queue depth, integration status, and KPI pace-to-goal
// (quarter targets from content_quarters.kpi_targets via usePace).

import { isInQueue } from '../pillars';
import { parseLocalDate } from '../dates';
import { startOfWeek } from './thisWeek';

export function computeAlerts({ entries, gsc, ac, pace }) {
  const alerts = [];

  // KPI pace-to-goal (usePace): quarter targets falling behind prorated
  // expectations get a caution; nothing behind gets folded into all-clear.
  for (const item of pace?.items || []) {
    if (item.behind) {
      alerts.push({
        tone: 'warn',
        title: `${item.label} behind pace.`,
        body: `${item.actual.toLocaleString()} so far vs ${Math.round(item.expected).toLocaleString()} expected at this point of the quarter (target ${item.target.toLocaleString()}).`,
      });
    }
  }

  const queueDepth = (entries || []).filter(e => isInQueue(e.status)).length;
  if (queueDepth === 0) {
    alerts.push({ tone: 'crit', title: 'Content queue is empty.', body: 'Nothing outlined, drafted, or scheduled. Surge block now.' });
  } else if (queueDepth === 1) {
    alerts.push({ tone: 'warn', title: 'Content queue is thin.', body: 'Only one item in flight. Plan a surge block within 7 days.' });
  }

  const weekStart = startOfWeek();
  const publishedThisWeek = (entries || []).filter(e =>
    e.status === 'published' && e.publishDate && parseLocalDate(e.publishDate) >= weekStart
  ).length;
  if (publishedThisWeek === 0) {
    alerts.push({ tone: 'warn', title: 'Nothing published this week yet.', body: 'Cadence target is 1 per week.' });
  }

  if (gsc && gsc.status && gsc.status.configured !== false && gsc.status.connected === false) {
    alerts.push({ tone: 'crit', title: 'Search Console is disconnected.', body: 'Reconnect from the SEO screen to restore search KPIs.' });
  }
  if (ac && ac.configured === false) {
    alerts.push({ tone: 'warn', title: 'ActiveCampaign is not configured.', body: 'Subscriber KPIs are dark until AC env vars are set.' });
  }

  if (alerts.length === 0) {
    const paced = pace?.items?.length > 0 ? ' KPIs on pace for the quarter.' : '';
    alerts.push({ tone: 'ok', title: 'All clear.', body: `Cadence on track, queue healthy, integrations up.${paced}` });
  }
  return alerts;
}
